import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function getAllPackageMovements(filters?: {
  search?: string;
  status_id?: number[];
  start_date?: string;
  end_date?: string;
  type_stock_id?: number;
  is_output?: boolean;
}) {
  const queryParams = new URLSearchParams();

  if (filters?.search) queryParams.append('search', filters.search);

  if (filters?.status_id && filters.status_id.length > 0) {
    filters.status_id.forEach((id) => {
      queryParams.append('status_id[]', id.toString());
    });
  }

  if (filters?.start_date) queryParams.append('init_date', filters.start_date);
  if (filters?.end_date) queryParams.append('end_date', filters.end_date);
  if (filters?.type_stock_id)
    queryParams.append('type_stock_id', filters.type_stock_id.toString());
  if (typeof filters?.is_output === 'boolean')
    queryParams.append('is_output', filters.is_output ? 'true' : 'false');

  const response = await axios.get(
    `${API_URL}catalogos/package-movement?${queryParams.toString()}`
  );
  const data = response.data?.doc?.data;
  return data;
}

export async function createPackMovement(body: any) {
  const { is_output, package_id, motive_id, detail, stock } = body;

  const response = await axios.post(`${API_URL}catalogos/package-movement`, {
    is_output: Boolean(is_output),
    package_id: Number(package_id),
    motive_id: Number(motive_id),
    detail: detail,
    stock: stock,
  });
  return response;
}

export async function updatePackMovement(body: any) {
  const { movement_id, motive_id, detail, stock } = body;

  const response = await axios.patch(
    `${API_URL}catalogos/package-movement/${movement_id}`,
    {
      motive_id: Number(motive_id),
      detail: detail,
      stock: stock,
    }
  );
  return response;
}
export async function getSelectMotive() {
  const response = await axios.get(`${API_URL}catalogos/motive`);
  const data = response.data.doc.data;
  let dataSelect: any = data;
  dataSelect.forEach((row: any) => {
    row.label = row.name;
    row.value = row.id;
    row.status_id = row.status_id;
  });
  return dataSelect;
}

// catalogos/package-movement/:id/stock

export async function getStockPackage(id_stock: number) {
  const response = await axios.get(
    `${API_URL}catalogos/package-movement/${id_stock}/stock`
  );
  const data = response.data.doc.data;
  return data;
}

export async function removeRegisterCatalog(id: number) {
  const response = await axios.delete(
    `${API_URL}catalogos/package-movement/${id}`
  );
  return response;
}

export async function downloadPackageReportPDF(id: number) {
  const date = new Date().toISOString().split('T')[0];

  try {
    const response = await axios({
      url: `${API_URL}reports/package/${id}/document/pdf`,
      method: 'GET',
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `REPORTE-PAQUETE-${id}-${date}.pdf`);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 0);
  } catch (error: any) {
    const parsed = await error.response.data.text();
    return JSON.parse(parsed);
  }
}

export async function downloadPackageReportZip(id: number) {
  const date = new Date().toISOString().split('T')[0];

  try {
    const response = await axios({
      url: `${API_URL}catalogos/package-movement/${id}/zip`,
      method: 'GET',
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'application/zip' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `REPORTE-PAQUETE-${id}-${date}.zip`);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 0);
  } catch (error: any) {
    const parsed = await error.response.data.text();
    return JSON.parse(parsed);
  }
}
